module.exports = __webpack_public_path__ + "img/Golden puffer.a58aa19b.png";